import {EsvgFiles, KPI4meColor} from 'frontier/nucleus';
import {TDBObject} from '../../../../../../../../src/app/api/generated';

export interface ISideNavContentCategory {
  title?: string;
  color: KPI4meColor;
  items: TSideNavContentItem[];
  icon?: EsvgFiles;
  opened?: boolean;
}

export interface ISidenavContentItem {
  title: string;
  icon?: string;
  tabId: string;
  beforeOpenedHandler?: () => void;
  helpText?: string;   // Tooltip text that will be displayed on hover of the help icon
  helpComponent?: any; // Component Reference that will be displayed in the help side panel
  alert?: TDBObject[]; // Enables attention icon signaling the user that there's a need for action
}

export interface ISideNavContentItemComponent extends ISidenavContentItem {
  componentName: string;
}

// type check for TSideNavContentItemComponent
export function isSideNavContentItemComponent(item: TSideNavContentItem): item is ISideNavContentItemComponent {
  return (item as ISideNavContentItemComponent).componentName !== undefined;
}

export interface ISideNavContentItemLink extends ISidenavContentItem {
  link: string;
}


export type TSideNavContentItem = ISideNavContentItemComponent | ISideNavContentItemLink;

